// extracted by mini-css-extract-plugin
export default {"btnpwd":"_073c59e3f2"};